export const initialState = {
  filters: {},
  exercises: [],
  exercise: {},
  loading: false,
  totalCount: 0
};
